<template>
  <div class="row">
    <div class="col-md-12 ml-auto mr-auto">
      <blockquote class="blockquote" style="border: 0px solid #e14eca;border-radius: 30px; background: #1c2233;">
        <div class="row">
          <div class="col-md-4 ml-auto mr-auto">
            <code class="text-center"><p class="text-warning" style="font-size: 20px">Add New Item</p></code>
          </div>
        </div>
        <div class="row" style="margin-top: -10px">
          <base-input class="col-lg-4 col-md-3"
                      label="Name of item"
                      v-model="article.name"
                      placeholder="item-name">
          </base-input>
          <base-input class="col-lg-4 col-md-3"
                      label="Description"
                      v-model="article.description"
                      placeholder="item-description">
          </base-input>
          <base-input v-if="projectId === '3'" class="col-lg-2 col-md-3"
                      label="Order"
                      v-model="article.office_order"
                      type="number"
                      placeholder="office-order">
          </base-input>
          <base-input v-else class="col-lg-2 col-md-3"
                      label="Order"
                      v-model="article.others_order"
                      type="number"
                      placeholder="others-order">
          </base-input>
          <base-input class="col-lg-2 col-md-3 col-6" label="Effect">
            <base-radio name="False" class="mb-3" v-model="article.is_expense">
              Income
            </base-radio>
            <base-radio name="True" class="mb-3" v-model="article.is_expense">
              Expense
            </base-radio>
          </base-input>
          <base-input v-if="article.name !== ''" class="col-md-4" style="margin-top: 25px">
            <transition name="view" appear enter-active-class="animated fadeIn delay" leave-active-class="animated fadeOut">
              <base-button class="clock-button" size="lg" simple block type="success" @click="addNew">Add item</base-button>
            </transition>
          </base-input>
          <div class="col-md-4" v-else></div>
          <div class="col-md-4"></div>
          <base-input v-if="showSave" class="col-md-4" style="margin-top: 25px">
            <transition name="view" appear enter-active-class="animated fadeIn delay" leave-active-class="animated fadeOut">
              <base-button class="clock-button" size="lg" simple block type="danger" @click="save">Save</base-button>
            </transition>
          </base-input>
          <div class="col-md-4" v-else></div>
        </div>
      </blockquote>
    </div>
  </div>
</template>

<script>
    export default {
      name: "NewArticles",
      props:['projectId','showSave', 'order'],
      data() {
        return {
          article:{
            article_id : 0,
            name: '',
            is_expense : 'False',
            description: '',
            office_order: 0,
            others_order: 0,
            is_delete: 0,
            office: 0,
            others: 0,
          },
        }
      },
      methods:{
        addNew(){
          this.article.is_expense = (this.article.is_expense === "True") ? 1 : 0;
          this.$emit('add-new', this.article);
          this.article = {
            name: '',
            is_expense : 'False',
            description: '',
            office_order: 0,
            others_order: 0,
            is_delete: 0,
            office: 0,
            others: 0,
          }
        },
        save(){
          this.$emit('save');
        },
      },
      created() {
        if (this.projectId === '3'){
          this.article.office = 1;
          this.article.office_order = this.order + 10;
        }
        else{
          this.article.others = 1;
          this.article.others_order = this.order + 10;
        }
      }
    }
</script>

<style scoped>

</style>
